import React, { useEffect } from "react";
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from './Components/ScrollToTop';
import Home from './Screens/Home';
import BrandView from "./Screens/BrandView";
import Product from './Screens/Product';
import Brands from "./Screens/Brands";
import ModalPop from "./Components/ModalPop";
import Privacy from "./Screens/Privacy";
import Terms from "./Screens/Terms";
import AboutUs from "./Screens/AboutUs";

function App() {
  useEffect(() => {
    const isLoggedInNow = (() => {
      try {
        const raw = localStorage.getItem('userid');
        if (!raw) return false;
        // you stored userid as JSON.stringify(data.uid)
        const parsed = JSON.parse(raw);
        return !!parsed;
      } catch {
        return !!localStorage.getItem('userid');
      }
    })();

    if (isLoggedInNow) return;
    if (sessionStorage.getItem('promoModalClosed') === '1') return;

    const bs = window.bootstrap; // from bootstrap.bundle JS
    const el = document.getElementById('modal_signup');

    const showModal = () => {
      if (!el || !bs?.Modal) return;
      const modal = bs.Modal.getOrCreateInstance(el, {
        backdrop: 'static',
        keyboard: false
      });

      // mark closed for this session when hidden
      el.addEventListener(
        'hidden.bs.modal',
        () => {
          sessionStorage.setItem('promoModalClosed', '1');
        },
        { once: true }
      );

      modal.show();
    };

    const timer = setTimeout(showModal, 20000);

    const cancelIfLoggedIn = () => {
      const raw = localStorage.getItem('userid');
      if (raw) {
        clearTimeout(timer);
        if (el && bs?.Modal) {
          bs.Modal.getOrCreateInstance(el).hide();
        }
      }
    };

    // listen for login across tabs
    const onStorage = (e) => {
      if (e.key === 'userid' && e.newValue) {
        cancelIfLoggedIn();
      }
    };
    window.addEventListener('storage', onStorage);

    // also poll same tab for safety
    const poll = setInterval(cancelIfLoggedIn, 500);

    return () => {
      clearTimeout(timer);
      clearInterval(poll);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <ScrollToTop />
        <ModalPop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brand/:id" element={<BrandView />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/product" element={<Product />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/aboutus" element={<AboutUs />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
